import React from "react";

import { Typography } from "antd";

import { ViewState } from "./RequirementsChecker";

interface RequirementsCheckerStarterScreenProps {
    setView: React.Dispatch<React.SetStateAction<ViewState>>
}

const RequirementsCheckerStarterScreen: React.FC<RequirementsCheckerStarterScreenProps> = ({ setView }) => {
    return (<>
        <Typography className="requirements-checker__title">
            Making Tax Digital (MTD) Requirement Checker
        </Typography>
        <div className="requirements-checker__starter">
            <div className="requirements-checker__description taLeft">
                From 6 April 2026, some sole traders and landlords must use compatible software, based on their total annual income from self-employment and property.
            </div>
            <div className="requirements-checker__description taLeft">
                This quick check will tell you:
            </div>
            <div className="requirements-checker__description">
                <ul className="requirements-checker__description">
                    <li className="taLeft">If MTD applies to you</li>
                    <li className="taLeft">When you'll need to start</li>
                    <li className="taLeft">What you'll need to do</li>
                </ul>
            </div>
            <div className="requirements-checker__description taLeft">
                You won't need any documents, just a rough idea of your income.
            </div>
        </div>
        <div className="requirements-checker__starter__buttons">
            <button
                className="requirements-checker__starter__buttons__start-button"
                onClick={() => setView(ViewState.Questionnaire)}
            >
                Check if MTD applies to you
            </button>
        </div>
    </>);
};

export default RequirementsCheckerStarterScreen;
